import React from 'react'
import { Form } from 'react-bootstrap'

const SearchView = ({ searchText, onChangeSearchText }) => (
  <>
    <Form.Group className='mb-3' controlId='searchText'>
      <Form.Label>Enter part of a name</Form.Label>
      <Form.Control
        type='text'
        placeholder='Enter at least three letters to search'
        value={searchText}
        onChange={e => onChangeSearchText(e.target.value)}
      />
    </Form.Group>
  </>
)

export default SearchView
